<script>
	export let accordion
	console.log('accordion:', accordion)

	function openItem(e) {
		let currentIsActive = e.target
			.closest('.accordion-block-item')
			.classList.contains('active')
		let elems = document.querySelectorAll('.accordion-block-item.active')
		let testimonialContent = e.target
			.closest('.accordion-block-item')
			.getElementsByClassName('accordion-block-item-content')[0]
		let contentHeight = undefined
		if (testimonialContent) {
			contentHeight = testimonialContent.clientHeight
		}

		;[].forEach.call(elems, function(e) {
			let svgWrap = e.querySelector('.accordion-block-svg-wrap-inner')
			//remove active class from all elements
			e.classList.remove('active')
			//reset padding
			e.style.paddingBottom = 0
		})

		if (currentIsActive == false) {
			//add active class to element targeted
			//the active class will be removed from an element that is already active
			e.target.closest('.accordion-block-item').classList.add('active')
			//add padding equivalent to content height
			e.target.closest('.accordion-block-item').style.paddingBottom =
				contentHeight + 'px'
		}
	}
</script>

{#each accordion as item}
	<div class="accordion-block-item" on:click={openItem}>
		{#if item.ID}
			<div class="elementSpacer" id={item.ID} />
		{/if}
		<div class="accordion-block-item-wrap">
			{#if item.headline}
				<div class="accordion-block-item-header">
					<div class="accordion-block-item-header-title">
						<span>
							{item.index.toLocaleString('en-US', {
								minimumIntegerDigits: 2,
								useGrouping: false,
							})}.
						</span>
						<p>
							{@html item.headline}
						</p>
					</div>
					<div class="accordion-block-svg-wrap">
						<div class="accordion-block-svg-wrap-inner">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								x="0"
								y="0"
								viewBox="0 0 16.5 16.5"
								xml:space="preserve">
								<style>
									.stplus {
										fill-rule: evenodd;
										clip-rule: evenodd;
										fill: #616161;
									}
								</style>
								<path
									class="stplus stplus-first"
									d="M6.9 16.5h2.7V0H6.9v16.5z" />
								<path class="stplus" d="M0 6.9h16.5v2.7H0z" />
							</svg>
						</div>
					</div>
				</div>
			{/if}
			<div class="accordion-block-item-content">
				{@html item.content}
			</div>
		</div>
	</div>
{/each}
